import { getInstance } from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/user-impersonation';

const UserImpersonationApi = {
  list: async () => {
    const instance = getInstance();
    const { data } = await instance.get<models.UserImpersonation>(
      `${BASE_URL}/list`
    );
    return data;
  },

  myLastAccess: async () => {
    const instance = getInstance();
    const { data } = await instance.get<models.UserImpersonationLastAccess[]>(
      `${BASE_URL}/my-last-access`
    );
    return data;
  },

  request: async (body: {
    impersonatorUserLogin: string;
    permissions: string[];
  }) => {
    const instance = getInstance();
    const { data } = await instance.post(`${BASE_URL}/request`, body);
    return data;
  },

  accept: async (id: string) => {
    const instance = getInstance();
    const { data } = await instance.patch(`${BASE_URL}/${id}/respond`, {
      action: 'accepted',
    });
    return data;
  },

  reject: async (id: string) => {
    const instance = getInstance();
    const { data } = await instance.patch(`${BASE_URL}/${id}/respond`, {
      action: 'rejected',
    });
    return data;
  },

  updatePermissions: async (
    id: string,
    body: { removePermissions?: string[]; addPermissions?: string[] }
  ) => {
    const instance = getInstance();
    const { data } = await instance.patch(
      `${BASE_URL}/${id}/permissions`,
      body
    );
    return data;
  },

  getUserToAccess: async (id: string) => {
    const instance = getInstance();
    const { data } = await instance.get<models.UserImpersonationToAccess>(
      `${BASE_URL}/user-to-access/${id}`
    );
    return data;
  },

  cancelUserImpersonation: async (userId: string) => {
    const instance = getInstance();
    const { data } = await instance.delete(
      `${BASE_URL}/user-to-cancel-impersonation/${userId}`
    );
    return data;
  },
};

export default UserImpersonationApi;
